var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { State } from "../../../hooks/useUseCase";
import { FoundQrCodePayload } from "./usecases/FindQrCodeUseCase";
import { ClosedQrCodeReaderDialogPayload } from "./usecases/CloseQrCodeReaderDialogUseCase";
import { DisabledCameraPayload } from "./usecases/DisableCameraUseCase";
var QrCodeReaderDialogState = /** @class */ (function (_super) {
    __extends(QrCodeReaderDialogState, _super);
    function QrCodeReaderDialogState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * カメラが無効であるか
         */
        _this.cameraDisabled = false;
        return _this;
    }
    QrCodeReaderDialogState.prototype.reduce = function (payload) {
        if (payload instanceof FoundQrCodePayload) {
            this.result = payload.result;
        }
        if (payload instanceof ClosedQrCodeReaderDialogPayload) {
            this.result = undefined;
        }
        if (payload instanceof DisabledCameraPayload) {
            this.cameraDisabled = true;
        }
    };
    return QrCodeReaderDialogState;
}(State));
export { QrCodeReaderDialogState };
